import React, { Component } from "react";
import { Header, Footer } from "./index";

class Layout extends Component {
  render() {
    return (
      <div>
        <Header />
        <main className="content">{this.props.children}</main>
        <Footer />
      </div>
    );
  }
}

export default Layout;
